export { default as Slider } from './Slider';
export * from './useSlider';